import {
  BrandL2RouteData,
  IntialSimulationData,
} from "~/server/data/brand_l2_route_data";
import { SimulatedTransactionDetails } from "~/server/types/brand";

export const getSimulateTransactionDetails = (
  initalSimulationData: IntialSimulationData | undefined
): SimulatedTransactionDetails | null => {
  return initalSimulationData &&
    initalSimulationData.initialSimulateTransactionDetails != null
    ? Array.isArray(initalSimulationData.initialSimulateTransactionDetails)
      ? initalSimulationData.initialSimulateTransactionDetails.length === 1
        ? initalSimulationData.initialSimulateTransactionDetails[0][0]
        : initalSimulationData.initialSimulateTransactionDetails[1][0]
      : initalSimulationData.initialSimulateTransactionDetails
    : null;
};

export const getSimulateTransactionDetails2 = (
  initalSimulationData: IntialSimulationData | undefined
): SimulatedTransactionDetails | null => {
  return initalSimulationData &&
    initalSimulationData.initialSimulateTransactionDetails != null
    ? Array.isArray(initalSimulationData.initialSimulateTransactionDetails)
      ? initalSimulationData.initialSimulateTransactionDetails[0][0]
      : initalSimulationData.initialSimulateTransactionDetails
    : null;
};

export const getSimulateError = (
  initalSimulationData: IntialSimulationData | undefined
): string | null => {
  return initalSimulationData &&
    initalSimulationData.initialSimulateError != null
    ? initalSimulationData.initialSimulateError
    : null;
};
